var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-favorite -action wt2-sg",class:{
    selected: _vm.isFavorite,
    '-progress': _vm.isFavoriteInProgress(),
  },attrs:{"title":_vm._f("culture")((_vm.isFavoriteInProgress()
      ? 'favorite.PROGRESS'
      : _vm.isFavorite
      ? 'favorite.REMOVE'
      : 'favorite.ADD'))},on:{"click":function($event){return _vm.onClick()}}},[_c('transition',{attrs:{"name":"wt2-fade-slow"}},[_c('wt-google-like-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFavoriteInProgress()),expression:"isFavoriteInProgress()"}],staticClass:"-default -progress"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }